import {useState} from 'react';
import FloatingOnlySelectBottomSheet from '../../../../../../../module/newShop/advertisementRegisteration/floatingOnlySelectBottomSheet';
import {BottomSheet} from 'react-spring-bottom-sheet';

interface IProps {
  guid: string;
  title: string;
}

interface IDropBottomSheetProps {
  data: Array<{guid: string; title: string}>;
  name: string;
  placeholder?: string;
  onChange: ({guid, title}: IProps) => void;
  value?: string;
  generalTitle?: string;
  generalDesc?: string;
  subDesc?: string;
  disabled?: boolean;
}

function DropBottomSheet({
  data,
  name,
  placeholder,
  onChange,
  value,
  generalTitle,
  generalDesc,
  subDesc,
  disabled,
}: IDropBottomSheetProps) {
  const [openBottomSheet, setOpenBottomSheet] = useState<boolean>(false);

  return !disabled ? (
    <div className="flex flex-col">
      <span className="text-md font-[500]">{generalTitle}</span>
      {generalDesc && <p className="my-3 text-md">{generalDesc}</p>}
      <FloatingOnlySelectBottomSheet
        Placeholder={placeholder}
        name={name}
        wrapperClass="border-gray-700"
        onClick={() => {
          setOpenBottomSheet(true);
        }}
        value={value}
        disabled={disabled}
      />
      <span className="text-xs text-gray-700 mt-1">{subDesc}</span>
      <BottomSheet
        onDismiss={() => setOpenBottomSheet(false)}
        open={openBottomSheet}
        blocking={true}
        snapPoints={({minHeight, maxHeight}) => [minHeight, maxHeight / 0.6]}
      >
        <div className="flex flex-col gap-2 p-4">
          {data?.map((item, index) => (
            <div
              key={item.guid ?? index}
              onClick={() => {
                onChange(item);
                setOpenBottomSheet(false);
              }}
            >
              {item?.title}
            </div>
          ))}
        </div>
      </BottomSheet>
    </div>
  ) : (
    <></>
  );
}

export default DropBottomSheet;
